import { render, staticRenderFns } from "./myTender.vue?vue&type=template&id=afc71f36&"
import script from "./myTender.vue?vue&type=script&lang=js&"
export * from "./myTender.vue?vue&type=script&lang=js&"
import style0 from "./myTender.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports